import React from 'react'
import { checkTranslation, chooseWallpaper, conditionalWidth, imageAddress, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import Modal from '../../components/Modal';
import FormViewer from '../../components/FormViewer';
import { Doughnut, Bar, Line, Pie } from 'react-chartjs-2';
// import CollapsibleButton from '../EmailManager/collapsibelButton';
import Collapsible from "react-collapsible";
// import GlobalUserInput from '../../components/inputs/GlobalUserInput';
import SettingsViewer from '../../components/SettingsViewer';
import Subtasks from './Eagleviews/subtasks';
import TableDateInput from '../../components/tableComponents/TableDateInput';
class TaskSingleView extends React.Component {
    state = {

        headers: [
            // { key: 'applet', type: 'SelectInput', col: '6', information: { label: '{{lang}}applet', placeholder: '{{lang}}applet', required: true } },
            // { key: 'title', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true } },
            // { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false }, showMain: false },
            { key: 'timeline', type: 'CalendarInput', information: { label: '{{lang}}desk.timeline', placeholder: '{{lang}}desk.timeline', required: false } },

            { key: 'assigne', type: 'GlobalUserInput', information: { label: '{{lang}}desk.Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.Select', required: false, } },

            // { key: 'assignee', type: 'SelectInput',  information: { label: '{{lang}}assignee', placeholder: '{{lang}}assignee', required: false } },
            { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}desk.priority', placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#CA5C72', bgColor: '#FEE9EE' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#CAA55C', bgColor: '#FEF2E9' }, { label: '{{lang}}desk.Low', key: 'low', color: '#00c875', bgColor: '#00c87520' }], required: false } },
        ],
        header: [
            { key: 'assignees', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.Select', required: false, } },
            // { key: 'assignee', type: 'MultiSelectInput', information: { label: '{{lang}}Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}select', required: false, } },

            { key: 'observer', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Observer', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.Select', required: false, } },

        ],
        actions: [
            {
                icon: "/assets/icons/applets/desk/airpod.left.svg",
                name: "{{lang}}desk.Done",
                item: [
                    { title: '{{lang}}desk.test' }
                ]
            },
            {
                icon: "/assets/icons/applets/desk/square.filled.and.line.vertical.and.square.png",
                name: "{{lang}}desk.Mirror",
                item: [
                    { title: '{{Lang}}desk.test' }
                ]
            },
            {
                icon: "/assets/icons/applets/desk/hand.point.up.braille.svg",
                name: "{{lang}}desk.Request For Permission",
                // item: [
                //     { title: 'test' }
                // ]
            },
            {
                icon: "/assets/icons/applets/desk/trash.svg",
                name: "{{lang}}desk.Remove",
                //  item: [
                //     { title: 'test' }
                // ]
            },
            {
                icon: "/assets/icons/applets/desk/plus.svg",
                name: "{{lang}}desk.Add Subtasks",
                // item: [
                //     { title: 'test' }
                // ]
            },
            {
                icon: "/assets/icons/applets/desk/power.dotted.svg",
                name: "{{lang}}desk.Start Track",
                // item: [
                //     { title: 'test' }
                // ]
            },
        ],
        chartOption: {
            legend: {
                display: false
            },
            responsive: true,
            maintainAspectRatio: false
        },

        data: {
            labels: ['{{lang}}desk.Done', "{{lang}}desk.Not Done"],
            datasets: [{
                data: [1, 2],
                backgroundColor: ['#ee5050', '#007aff']
            }]

        },
        isOpen: false,
        title: '',
        extra: ""

    }


    componentDidMount() {
        this.getSubTask()
        this.setState({ title: this.props.data.title })
    }

    componentWillUnmount() {
    }
    getSubTask = () => {

    }

    changePage = (item) => {
        this.setState({ currentPage: item.key })
    }


    taskDone = (item) => {
        let tasks = this.state.tasks
        // tasks[item._id] = !item.done
        tasks.forEach((task, index) => {
            if (item._id == task._id) {
                tasks[index].done = !item.done
            }
        });

        this.setState({ tasks })
    }

    showInfo = (item) => {

        this.setState({ sideOpen: true, showConfig: false }, () => {
            this.setState({ showConfig: true })
        })

        // this.addModal.showModal()
    }

    addClicked = (open) => {

        this.setState({ sideOpen: open != null ? open : true, showConfig: false }, () => {
            this.setState({ showConfig: true })
        })

        // this.addModal.showModal()
    }


    saveSetting = (key, value, files, cb) => {
        console.log(key)
        console.log(value)

        // setTimeout(() => {
        cb(true)

        // this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.savedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })

        // }, 500);
    }
    updateAssignees = () => {
        let assigneeForm = this.assigneeForm.getForm()
        this.props.updateTask(assigneeForm, 'assignees', null)
    }
    chengecollaps = () => {
        // let isOpen = this.state.isOpen
        // isOpen = {}
        // isOpen[index] = !isOpen[index]

        this.setState({ isOpen: !this.state.isOpen })

    }
    changeValue = (key, data) => {
        let title = this.state.title
        console.log('title', title)
        console.log('data', data)
        title = data
        console.log('title', title)
        console.log('data', data)
        this.setState({ title })
    }

    render() {
        return (

            <div className="modal-body scroll-no-scrollbar h-100 py-4   " style={{ borderRadius: '0px 8px 8px 0px' }}>

                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className='flexcb'>

                        <button onClick={() => { this.chengecollaps() }}
                            // onClick={() => this.addClicked()}
                            className='px-1 py-1  flexcb '
                            style={{ background: 'linear-gradient(to right,#FEB764, #FE9B64)', borderRadius: 8, color: '#fff', transition: 'all 0.5s', marginLeft: "1rem" }}>
                            <div onClick={() => this.addClicked()} className='px-1 py-1  flexcb '
                                style={{ background: 'linear-gradient(to right,#FEB764, #FE9B64)', borderRadius: 8, color: '#fff', transition: 'all 0.5s', }}>
                                <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("desk.Action")}</p>
                                <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                                    <img className='invert' src='/assets/icons/useful/angle-right.svg' height={18} style={{ transform: "rotate(90deg" }} />
                                </div>
                            </div>
                        </button>
                        <div>
                            <div>
                                <img src={"/assets/icons/useful/more-v.svg"} height={14} />
                            </div>
                        </div>
                    </div>
                    <div className='action-list shadow-2 br-10 px-2'>
                        <Collapsible open={this.state.isOpen} >
                            {this.state.actions.map((prop, index) => {
                                return (
                                    <>
                                        <div className='action-option px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' style={{ cursor: "pointer" }} onClick={() => this.props.addSubtask(prop.name)}>
                                            <img src={prop.icon} />
                                            <p>{checkTranslation(prop.name)}</p>
                                        </div>

                                    </>
                                )
                            })}
                        </Collapsible></div>

                </div>

                {/* <div className='flexcb px-3 mb-2'>
                                <div className='flexc'>
                                    <div className='py-1 px-2  task-priority' style={{ backgroundColor: '#FEE9EE', color: '#CA5C72', borderRadius: 4 }}>
                                        <p className=' text-smallest text-semibold'>TO DO</p>
                                    </div>
                                </div>
                            </div> */}


                <div className=' mb-3 mt-3'>

                    <div className='px-3 flexcb'>
                        <div className=''>

                            <p className=' text-smaller text-semibold' style={{ color: '#5C7BCA', }}>{translate('desk.Recurring Task')}</p>

                            <p className='text-semibold text-semibig mt-0' style={{ padding: ".5rem 0rem  " }}>{checkTranslation(this.props.data?.title)}</p>

                            <TableDateInput header={{ key: '', information: { placeholder: 'date' } }} data={this.state.title} changeValue={this.changeValue} extra={this.state.extra} />
                            {this.state.title != this.props.data.title && (
                                <button onClick={() => this.props.updateTask(this.props.data, 'title', this.state.title)}>{translate('desk.Save')}</button>
                            )}
                            <FormViewer ref={el => this.assigneeForm = el} headers={this.state.header} initData={this.props.data} inputClass={'modern-input'} />
                            {console.log('assigneeForm', this.assigneeForm)}
                            <button onClick={() => this.updateAssignees()}>{translate('desk.Save')}</button>


                            <div className='flexc '>
                                <img className='task-check-img' src={imageAddress(this.state.current?.user?.image, 'profile')} height={14} width={14} style={{ borderRadius: 20 }} />
                                <p className='task-applet-name text-smaller color-gray-2  cursor-pointer mx-1 text-semibold'>Elitive {translate('desk. Tasks Applet')}</p>
                            </div>
                        </div>

                        <div className='py-1 px-2  task-priority' style={{ backgroundColor: '#FEE9EE', color: '#CA5C72', borderRadius: 4 }}>
                            <p className=' text-smallest text-semibold'>{translate('desk.TO DO')}</p>
                        </div>

                    </div>


                    {this.props.data['**subTaskCount'] != 0 && (
                        <div className='mt-3 py-3 px-3 cursor-pointer' style={{ backgroundColor: '#f6f6f6' }} onClick={() => this.props.showSubtask(this.props.data)}>
                            <div className='flexcb'>
                                <p className='task-applet-name text-smaller color-gray-2  text-semibold '>{translate('desk.SubTasks')}</p>
                                <p className='text-small '>{this.props.data['**subTaskCount']} {translate('desk.Subtasks')}</p>

                                <div className='position-relative flexc' style={{ backgroundColor: '#ee5050', height: 10, width: 100, borderRadius: 4, overflow: 'hidden' }}>
                                    <div className=' h-100' style={{ width: '73%', left: 0, backgroundColor: 'rgb(0, 205, 116)' }}>
                                    </div>

                                    <div className=' h-100' style={{ width: '10%', left: 0, backgroundColor: 'rgb(255, 197, 0)' }}>
                                    </div>

                                </div>


                                <div className='flexcc'>
                                    <img src='/assets/icons/useful/angle-right.svg' height={18} />

                                </div>

                            </div>
                        </div>
                    )}


                    <div className='mt-3 px-3'>
                        <div className='flexc'>
                            <p className='task-applet-name text-smaller color-gray-2 text-semibold'>{translate('Description')}</p>
                            <div className='mx-2 flexcc' >
                                <div className='position-relative'>

                                    {this.state.showAddDescription && (
                                        <div className='position-absolute pt-3 px-2 pb-3' style={{ zIndex: 1, top: 24, backgroundColor: '#fff', boxShadow: '0px 0px 100px #10101040', borderRadius: 8, }}>
                                            <button className='flexc'>
                                                <img className='' style={{ opacity: 0.8 }} src='/assets/icons/useful/clip.svg' height={14} />
                                                <p className='text-small  mld-3 color-gray-3 '>{translate('desk.Attachment')}</p>
                                            </button>

                                            <button className='flexc mt-2'>
                                                <img className='' style={{ opacity: 0.8 }} src='/assets/icons/useful/save.png' height={14} />
                                                <p className='text-small  mld-3 color-gray-3 '>{translate('desk.Drive')}</p>
                                            </button>


                                            <button className='flexc mt-2'>
                                                <img className='' style={{ opacity: 0.8 }} src='/assets/icons/useful/text.svg' height={14} />
                                                <p className='text-small  mld-3 color-gray-3 '>{translate('desk.Editor')}</p>
                                            </button>

                                            <button className='flexc mt-2'>
                                                <img className='' style={{ opacity: 0.8 }} src='/assets/icons/useful/microphone.svg' height={14} />
                                                <p className='text-small  mld-3 color-gray-3 '>{translate('desk.Voice')}</p>
                                            </button>

                                        </div>
                                    )}

                                    <button className={'flexcc transition-all ' + (this.state.showAddDescription ? 'rotate-45' : '')} onClick={() => this.setState({ showAddDescription: !this.state.showAddDescription })} style={{ zIndex: 1, backgroundColor: '#eee', borderRadius: 20, width: 20, height: 20 }}>
                                        <img className='opacity-5' src='/assets/icons/useful/plus.svg' height={14} />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p className=' mt-2 pb-3' style={{ fontSize: 13, borderBottom: '1px solid #f6f6f6' }}>{checkTranslation(this.props.data?.description)}</p>
                        {/* <FormViewer ref={el => this.form1 = el} headers={this.state.header} initData={this.props.data} inputClass={'modern-input'} /> */}
                    </div>


                    <div className='px-3'>
                        <SettingsViewer ref={el => this.form = el} saveSetting={this.saveSetting} headers={this.state.headers} initData={this.props.data} errors={this.state.errors} formClass={'settings-desk'} inputClass={'modern-input'} hideEditButton={true} singleSide={true} labelWidth={80} />
                    </div>


                    {/* <div className='mt-2 px-3 d-flex'>
                        <p className='task-applet-name text-smaller color-gray-2  mt-1 text-semibold' style={{ minWidth: 70 }}>Timeline</p>
                        <div className='mx-3 w-100 pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                            <p className='text-smaller color-gray-3 mt-1'>Current month, 2 Days</p>
                            <p className='text-smaller color-gray-3 mt-1'>Allocated 1 Day</p>

                            <div className='flexc'>
                               
                            </div>
                        </div>
                    </div>


                    <div className='mt-2 px-3 d-flex'>
                        <p className='task-applet-name text-smaller color-gray-2  mt-1 text-semibold' style={{ minWidth: 70 }}>Assignee</p>

                        <div className='flexc mx-3 pb-2 w-100' style={{ borderBottom: '1px solid #f6f6f6' }}>

                            <img className='task-check-img' src={imageAddress(this.state.current?.user?.image, 'profile')} height={14} width={14} style={{ borderRadius: 20 }} />
                            <p className='text-smaller color-gray-3 mx-1'>Pouya Pezhman</p>
                        </div>
                    </div>


                    <div className='mt-2 px-3 d-flex'>
                        <p className='task-applet-name text-smaller color-gray-2   text-semibold' style={{ minWidth: 70 }}>Priority</p>
                        <div className='flexc mx-3 pb-2 w-100' style={{ borderBottom: '1px solid #f6f6f6' }}>
                            <div className='py-1 px-2  task-priority' style={{ backgroundColor: '#FEE9EE', color: '#CA5C72', borderRadius: 4 }}>
                                <p className=' text-smallest text-semibold'>High</p>
                            </div>
                        </div>
                    </div> */}




                </div>




                <div className='px-3'>

                    <p className='task-applet-name text-smaller color-gray-2   text-semibold' style={{ minWidth: 70 }}>{translate('desk.Activity Log')}</p>
                    <p className='task-applet-name text-smaller color-gray-2   text-semibold' style={{ minWidth: 70 }}>{translate('desk.Comments')}</p>
                    <p className='task-applet-name text-smaller color-gray-2   text-semibold' style={{ minWidth: 70 }}>{translate('desk.Messages')}</p>



                </div>





                {/* <div className='mt-3'>
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.initData} errors={this.state.errors} formClass="bordered-form" inputClass={'bordered-input'} />
                            </div> */}


                {/* <div className={"px-3"} style={{ maxWidth: 250 }}>
                                <button onClick={() => this.addClicked()} className='px-1 py-1 w-100 flexcb ' style={{ background: 'linear-gradient(to right,#FEB764, #FE9B64)', borderRadius: 8, color: '#fff', transition: 'all 0.5s', }}>
                                    <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Submit")}</p>
                                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                                        <img className='invert' src='/assets/icons/useful/angle-right.svg' height={18} />
                                    </div>
                                </button>


                                <button onClick={() => this.addClicked()} className='px-1 py-1 w-100 flexcb mt-2 saturate-with-hover' style={{ background: 'linear-gradient(to right,#FEB764, #FE9B64)', borderRadius: 8, color: '#fff', transition: 'all 0.5s', }}>
                                    <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Submit, Add New")}</p>
                                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                                        <img className='invert' src='/assets/icons/plus.svg' height={18} />
                                    </div>
                                </button>

                            </div> */}

            </div >


        )
    }
}

export default TaskSingleView;